<template>
  <div>
    <Navigation></Navigation>
    <!--<Subnav></Subnav>-->
  </div>
</template>

<script>
import Navigation from './header/navigation.vue'
export default {
  components: {
    Navigation
    // Subnav
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="less" scoped>
  @import "header";
</style>



// WEBPACK FOOTER //
// src/layout/header.vue